import React from 'react';
import { Section } from './ui/Section';
export function Authority() {
  return <Section variant="alt" data-id="element-18">
      <div className="max-w-4xl mx-auto bg-white border border-brand-border rounded-lg p-6 md:p-8 shadow-sm" data-id="element-19">
        <div className="flex items-start gap-4" data-id="element-20">
          {/* Shield icon - SVG inline, no external library */}
          <div className="shrink-0" data-id="element-21">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-brand-primary" data-id="element-22">
              <path d="M12 2L4 6V11C4 16.55 7.84 21.74 12 23C16.16 21.74 20 16.55 20 11V6L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" fill="none" data-id="element-23" />
              <path d="M9 12L11 14L15 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-24" />
            </svg>
          </div>

          <div data-id="element-25">
            <h3 className="font-display text-xl md:text-2xl font-bold text-brand-primary mb-3" data-id="element-26">
              Un sistema diseñado bajo estándares españoles
            </h3>
            <p className="font-body text-brand-text leading-relaxed" data-id="element-27">
              Psicólogo en Acción ha sido desarrollado por un equipo de
              Psicólogos Colegiados con experiencia real en el sector privado en
              España. No es teoría académica: son los protocolos, contratos y
              estrategias que usamos cada día en nuestras propias consultas para
              cumplir con el Colegio Oficial de Psicología (COP) y la
              legislación vigente.
            </p>
          </div>
        </div>
      </div>
    </Section>;
}